import { ComponentType } from '@wix/a11y-adapters';
export let DsDataSource = /*#__PURE__*/function (DsDataSource) {
  DsDataSource["Studio"] = "studio";
  DsDataSource["Platformized"] = "platformized";
  return DsDataSource;
}({});
export const AUTO_DOM_ORDER_DATE = new Date('2024-11-07');
export let ProductsDataSource = /*#__PURE__*/function (ProductsDataSource) {
  ProductsDataSource["Graphql"] = "graphql";
  ProductsDataSource["V1"] = "v1";
  ProductsDataSource["V3"] = "v3";
  return ProductsDataSource;
}({});
export const A11Y_RULES_EXPERIMENTS = {
  DISABLE_ALT_TEXT_AND_MEDIA_ALT_FOR_TEMPLATES_QA: 'specs.a11y.disableAltTextAndMediaAltForTemplatesQA',
  ENABLE_A11Y_AXE_REPORT: 'specs.responsive-editor.EnableA11yAxeReport',
  ENABLE_A11Y_EVENTS_ALT_RULE_MAIN_IMAGES: 'specs.responsive-editor.EnableA11yEventsAltRuleMainImages',
  ENABLE_A11Y_INACCESSIBLE_COMPONENTS_RULE: 'specs.responsive-editor.EnableInaccessibleComponentsRule',
  ENABLE_EQUAL_RATIO_COLOR_CONTRAST: 'specs.a11y.enableEqualRatioColorContrast',
  ENABLE_GLOBAL_SECTION_FOR_INCOMPLETE_ELEMENTS: 'specs.a11y.enableGlobalSectionForIncompleteElements',
  ENABLE_INACCESSIBLE_LAYOUT_RULE: 'specs.responsive-editor.EnableInaccessibleLayoutRule',
  ENABLE_PAGE_AUTO_DOM_ORDER: 'specs.a11y.enablePageAutoDomOrder',
  ENABLE_RTL_DOM_ORDER: 'specs.responsive-editor.EnableRTLDomOrder',
  ENABLE_TITLE_TAG_RULE: 'specs.responsive-editor.EnableA11yAxeReport',
  HIDE_SITE_DOM_ORDER: 'specs.a11y.hideSiteDomOrder'
};
export const CONTAINER_COMPONENT_TYPES = [ComponentType.Section, ComponentType.ClassicSection, ComponentType.FooterSection, ComponentType.HeaderSection, ComponentType.Column, ComponentType.HeaderContainer, ComponentType.FooterContainer, ComponentType.StripContainerSlideShowSlide, ComponentType.StripColumnsContainer, ComponentType.PaginatedGridGallery, ComponentType.BoxSlideShow, ComponentType.BoxSlideShowSlide, ComponentType.Tabs];

// To do - studio needs to expose this array
// https://github.com/wix-private/document-management/blob/62ef609b0fddbf26701d620cc81a1165945579c1/document-services-implementation/src/siteMetadata/generalInfoUtils.ts#L1
export const RTL_LANGUAGES = ['ar', 'arc', 'bcc', 'bqi', 'ckb', 'dv', 'fa', 'glk', 'ha', 'he', 'khw', 'ks', 'ku', 'mzn', 'pnb', 'ps', 'sd', 'ug', 'ur', 'yi'];
export const MASTER_PAGE_ID = 'masterPage';
export let MembersCustomPageManagedByWixAppId = /*#__PURE__*/function (MembersCustomPageManagedByWixAppId) {
  MembersCustomPageManagedByWixAppId["SignUp"] = "5f4fa4f1-5afd-4ac0-8a85-e5ac1d2b9b7d";
  MembersCustomPageManagedByWixAppId["SignIn"] = "bbe1406a-31f5-4f3f-9e0a-b39dfd25274f";
  return MembersCustomPageManagedByWixAppId;
}({});
export const DEFAULT_BRANCH_ID = '00000000-0000-0000-0000-000000000000';
//# sourceMappingURL=constants.js.map